<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap" style="background: white">
      <div class="modal-inner whole">
        <div class="body modal coupon-modal">
          <header class="header">
            <div class="inner">
              <div class="area">
                <div class="header_btn">
                  <button class="header_btn prev"></button>
                </div>

                <h1 class="header_tit text">
                  <p class="i-back" @click="emit('close')"></p>
                  {{ $t('order.on_going.label.coupon') }}
                </h1>
              </div>
            </div>
          </header>

          <div class="modal-con modal_full coupon-modal__content">
            <main class="main coupon-main" role="main">
              <div class="inner coupon-content">
                <p v-if="coupons.length === 0" class="coupon-empty">
                  사용 가능한 쿠폰이 없습니다.
                </p>

                <ul v-else class="coupon-list">
                  <li
                    v-for="item in coupons"
                    :key="`coupon_${item.couponBoxNo}`"
                    class="coupon-list__item"
                  >
                    <button
                      type="button"
                      class="coupon-card"
                      :class="{
                        'coupon-card--selected':
                          (selected?.couponBoxNo ?? -1) === item.couponBoxNo
                      }"
                      :aria-pressed="
                        (selected?.couponBoxNo ?? -1) === item.couponBoxNo
                      "
                      @click="select(item)"
                    >
                      <span class="coupon-card__image-wrap">
                        <img
                          v-if="item.file?.storedFileName"
                          class="coupon-card__image"
                          :src="getImagePath(item.file?.storedFileName)"
                          alt=""
                        />
                        <span
                          v-else
                          class="coupon-card__image-placeholder"
                          aria-hidden="true"
                        ></span>
                      </span>

                      <span class="coupon-card__body">
                        <span class="coupon-card__heading">
                          <span class="coupon-card__title-wrap">
                            <span v-if="item.store" class="coupon-card__store">
                              {{ renderStore(item.store) }}
                            </span>
                            <span class="coupon-card__title">{{ item.titleKr }}</span>
                          </span>

                          <span class="coupon-card__indicator" aria-hidden="true">
                            ✓
                          </span>
                        </span>

                        <strong class="coupon-card__discount">
                          {{ renderDiscount(item.discount, item.isPercentage) }}
                        </strong>

                        <span class="coupon-card__details">
                          <span class="coupon-card__detail">
                            <span class="coupon-card__detail-label">
                              {{ $t('tag.card.required_pay_amount') }}
                            </span>
                            <span class="coupon-card__detail-value">
                              {{ toVn(item.minimumUsageAmount) }}
                            </span>
                          </span>

                          <span class="coupon-card__detail">
                            <span class="coupon-card__detail-label">
                              {{ $t('admin.manage.issue_coupon.card.expire') }}
                            </span>
                            <span class="coupon-card__detail-value">
                              {{
                                renderDate(
                                  item.startDate,
                                  item.endDate,
                                  item.isNoTimeLimit
                                )
                              }}
                            </span>
                          </span>
                        </span>
                      </span>
                    </button>
                  </li>
                </ul>
              </div>
            </main>
          </div>

          <div class="btm_btn btn-type02 coupon-footer">
            <button type="button" class="coupon-footer__button yd-cta yd-cta--primary" @click="apply">
              <p>{{ $t('my.coupon.save_btn') }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, toRefs } from 'vue';
import { toVn } from '@/common/utils/Currency';
import { toYmd } from '@/common/utils/Dates';
import { useI18n } from 'vue-i18n';
import { getImagePath } from '@/common/constants/ConstCode';
import { useStore } from 'vuex';

const $store = useStore();

const { t } = useI18n();

onMounted(() => {
  const coupon = $store.getters['payment/getCoupon'];
  if (coupon) selected.value = coupon;
});
const { data } = defineProps(['data']);
const { storeNo, minimumPrice } = toRefs(data);
const selected = ref(null);
const coupons = computed(() =>
  $store.getters['user/getCoupons']
    .filter((elem) => elem.issuedBy === -1 || elem.issuedBy === storeNo.value)
    .filter((elem) => elem.minimumUsageAmount < minimumPrice.value)
);
const emit = defineEmits(['close']);

const renderStore = (store) => {
  // if (!store) return 'youthMarket';
  return store.nameKr;
};
const renderDiscount = (discount, isPercentage) => {
  return isPercentage ? `${discount * 100} %` : `${toVn(discount)}`;
};
const renderDate = (start, end, isNoLimit) => {
  if (isNoLimit) return t('admin.manage.issue_coupon.create.no_expire');
  return `${toYmd(start)} ~ ${toYmd(end)}`;
};
const select = (item, index) => {
  if ((selected?.value?.couponBoxNo ?? -1) === item.couponBoxNo) selected.value = null;
  else {
    selected.value = item;
  }
};
const apply = () => {
  $store.commit('payment/setCoupon', selected.value);
  emit('close');
};
</script>

<style scoped>
.coupon-modal {
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: none;
  background: #ffffff;
  border-radius: 0;
}

.coupon-modal__content {
  min-height: 0;
  padding: 0;
  overflow: hidden;
}

.coupon-main {
  min-height: 0;
  background: #ffffff;
  font-size: 1.4rem;
}

.coupon-content {
  box-sizing: border-box;
  padding: 1rem 1rem calc(8.8rem + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
}

.coupon-list {
  display: grid;
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.coupon-list__item {
  margin: 0;
}

.coupon-card {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 1.2rem;
  gap: 1.2rem;
  color: #263746;
  font: inherit;
  text-align: left;
  border: 1px solid #e5edf2;
  border-radius: 1.2rem;
  background: #ffffff;
  box-shadow: none;
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    border-color 0.18s ease;
}

.coupon-card--selected {
  border-color: #a9dafa;
  background: #eef8fe;
}

.coupon-card:focus-visible {
  outline: 2px solid #4DA9E8;
  outline-offset: 2px;
}

.coupon-card__image-wrap {
  position: relative;
  display: block;
  flex: 0 0 8rem;
  width: 8rem;
  height: 8rem;
  overflow: hidden;
  border-radius: 1rem;
  background: #f2f5f7;
}

.coupon-card__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.coupon-card__image-placeholder {
  display: block;
  width: 100%;
  height: 100%;
  background:
    linear-gradient(#e1e7eb 0 0) 1.4rem 5.4rem / 5.2rem 0.7rem no-repeat,
    linear-gradient(#e7ecef 0 0) 1.4rem 3.9rem / 3.6rem 0.7rem no-repeat,
    #f2f5f7;
}

.coupon-card__body {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
}

.coupon-card__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
}

.coupon-card__title-wrap,
.coupon-card__title,
.coupon-card__store,
.coupon-card__details,
.coupon-card__detail {
  display: block;
}

.coupon-card__title-wrap {
  min-width: 0;
}

.coupon-card__store {
  margin-bottom: 0.2rem;
  color: #758491;
  font-size: 1.2rem;
  line-height: 1.4;
}

.coupon-card__title {
  color: #263746;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.4;
}

.coupon-card__indicator {
  display: inline-flex;
  flex: 0 0 2.2rem;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  color: transparent;
  font-size: 1.3rem;
  font-weight: 700;
  border: 1px solid #cbd8e0;
  border-radius: 50%;
  background: #ffffff;
}

.coupon-card--selected .coupon-card__indicator {
  color: #ffffff;
  border-color: #7EC8F5;
  background: #7EC8F5;
}

.coupon-card__discount {
  display: block;
  margin-top: 0.6rem;
  color: #318bc3;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.3;
}

.coupon-card__details {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #edf2f5;
}

.coupon-card__detail {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  color: #667783;
  font-size: 1.2rem;
  line-height: 1.5;
}

.coupon-card__detail + .coupon-card__detail {
  margin-top: 0.4rem;
}

.coupon-card__detail-label {
  flex: 0 0 auto;
}

.coupon-card__detail-value {
  min-width: 0;
  color: #435664;
  text-align: right;
}

.coupon-empty {
  display: flex;
  min-height: calc(100dvh - 15rem);
  margin: 0;
  align-items: center;
  justify-content: center;
  color: #758491;
  font-size: 1.4rem;
  text-align: center;
}

.coupon-footer {
  position: fixed;
  z-index: 2;
  right: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
}

.coupon-footer .coupon-footer__button {
  display: flex;
  width: 100%;
  height: 48px;
  margin: 0;
  padding: 0 1rem;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 600;
  border: 0;
  border-radius: 1rem;
  background: #7EC8F5;
  cursor: pointer;
}

.coupon-footer .coupon-footer__button:active {
  background: #4DA9E8;
}

.coupon-footer .coupon-footer__button:focus-visible {
  outline: 2px solid #318bc3;
  outline-offset: 2px;
}

.coupon-footer__button p {
  margin: 0;
}

@media (max-width: 359px) {
  .coupon-card {
    padding: 1rem;
    gap: 1rem;
  }

  .coupon-card__image-wrap {
    flex-basis: 6.8rem;
    width: 6.8rem;
    height: 6.8rem;
  }

  .coupon-card__image-placeholder {
    background:
      linear-gradient(#e1e7eb 0 0) 1.2rem 4.6rem / 4.4rem 0.6rem no-repeat,
      linear-gradient(#e7ecef 0 0) 1.2rem 3.3rem / 3.2rem 0.6rem no-repeat,
      #f2f5f7;
  }
}
</style>
/* *Created on 2023-10-16 *ProjectName user */
